var langselectortoggle = document.getElementById('langSelectorOpener');
var langselectorpanel = document.getElementById('langSelectorPanel');
var langselectorpanelbg = document.getElementById('langSelectorPanelBg');  
var langselectorclose = document.getElementById('langSelectorCloseBtn'); 
var langselectortoggleInDrawer = document.getElementById('langSelectorOpenerDrawer');
var langselectortoggleInHeader = document.getElementById('langSelectorOpenerHeader');
var lastFocusedLangSelectorButton = null;

if(langselectortoggle) {
  langselectortoggle.addEventListener('click', function() {
    lastFocusedLangSelectorButton = langselectortoggle;
    langselectorpanel.classList.add('open');
    langselectorpanelbg.classList.add('open');
    trapFocus(langselectorpanel, langselectorclose);
    event.preventDefault();
  });  
}

if(langselectortoggleInDrawer && langselectorpanel) {
  langselectortoggleInDrawer.addEventListener('click', function() {
    lastFocusedLangSelectorButton = langselectortoggleInDrawer;
    langselectorpanel.classList.add('open');
    langselectorpanelbg.classList.add('open');
    trapFocus(langselectorpanel, langselectorclose);
  });  
}

if(langselectortoggleInHeader && langselectorpanel) {
  langselectortoggleInHeader.addEventListener('click', function() {
    lastFocusedLangSelectorButton = langselectortoggleInHeader;
    langselectorpanel.classList.add('open');
    langselectorpanelbg.classList.add('open');
    trapFocus(langselectorpanel, langselectorclose);
  });  
}

langselectorclose.addEventListener('click', function() {
  langselectorpanel.classList.remove('open');
  langselectorpanelbg.classList.remove('open');
  removeTrapFocus(lastFocusedLangSelectorButton);
  event.preventDefault();
});

langselectorpanelbg.addEventListener('click', function() {
  this.classList.remove('open');
  langselectorpanel.classList.remove('open');
  removeTrapFocus(lastFocusedLangSelectorButton);
});

if (langselectorpanel) {
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && langselectorpanel.classList.contains('open')) {
      event.stopImmediatePropagation();
      langselectorpanel.classList.remove('open');
      langselectorpanelbg.classList.remove('open');
      removeTrapFocus(lastFocusedLangSelectorButton);
      event.preventDefault();
    }
  });
}